import clsx from 'clsx'
import React, {cloneElement, isValidElement} from 'react'

import {Grid} from '../grid'
import {PropsWithClasses} from '../theme/UNSTABLE_makeStyles'
import {Typography} from '../typography'
import {ClassKey, useClasses} from './Chip.classes'

type Props = PropsWithClasses<ClassKey> &
  JSX.IntrinsicElements['div'] & {
    icon?: React.ReactNode
    label?: React.ReactNode
    className?: string
  }

const Chip: React.FC<React.PropsWithChildren<Props>> = ({icon, label, className, classes: classesProp, ...props}) => {
  const classes = useClasses(classesProp)
  const iconElement =
    icon && isValidElement(icon)
      ? cloneElement(icon, {
          className: clsx(classes.icon, icon.props.className),
        })
      : null

  return (
    <div className={clsx(classes.root, className)} {...props}>
      {iconElement}
      {label && (
        <Typography className={classes.label} variant="caption1">
          <Grid className={classes.textWrap}>{label}</Grid>
        </Typography>
      )}
    </div>
  )
}

export type {Props}

export default Chip
